import React from "react";
import { AdditionalCard } from "../components/additional-card";
import topics from "../additional-data/topic";
import Header from "../components/header";

import "./style.css";

const AdditionalTest = () => {
  return (
    <>
      <Header title={"Нэмэлт тест"} />
      <div className="topic-body">
        <div className="container">
          <div className="topic-cards">
            {topics.map((el) => (
              <AdditionalCard
                key={el.id}
                name={el.topics_name}
                number={el.id}
                questions={el.question_number}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalTest;
